// D-322 (6): the "approve browser notices" bar. Pure helpers (no DOM) so the rules are unit-tested.
// "לא עכשיו" hides the bar until TOMORROW only (local date), never forever.

export const PUSH_DISMISSED_ON_KEY = 'ote_push_dismissed_on';

type Store = Pick<Storage, 'getItem' | 'setItem'>;

export function localDay(now: Date = new Date()): string {
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${m}-${d}`;
}

export function isDismissedToday(store: Store | null, now: Date = new Date()): boolean {
  try {
    return !!store && store.getItem(PUSH_DISMISSED_ON_KEY) === localDay(now);
  } catch {
    return false;
  }
}

export function dismissUntilTomorrow(store: Store | null, now: Date = new Date()): void {
  try {
    store?.setItem(PUSH_DISMISSED_ON_KEY, localDay(now));
  } catch { /* storage blocked: the bar simply returns on the next visit */ }
}

export type PushBarMode = 'hidden' | 'ask' | 'denied' | 'server_missing';

/** What the bar shows. First visit already counts (no visit threshold). */
export function pushBarMode(input: {
  isStaff: boolean;
  supported: boolean;
  permission: NotificationPermission | 'unsupported';
  subscribed: boolean;
  dismissedToday: boolean;
  serverConfigured: boolean;
  /** FIX-D323-F3: the OTE manager is told when the SERVER cannot send (no VAPID keys / switch off); others see nothing. */
  isAdmin?: boolean;
}): PushBarMode {
  if (!input.isStaff || !input.supported) return 'hidden';
  if (!input.serverConfigured) return input.isAdmin && !input.dismissedToday ? 'server_missing' : 'hidden';
  if (input.dismissedToday) return 'hidden';
  if (input.permission === 'denied') return 'denied';
  if (input.permission === 'granted' && input.subscribed) return 'hidden';
  return 'ask';
}
